interface AnalyticsAppIdentity {
  id: string
  name: string
  path: string
}

// Never use a stale shell router or a broad prefix match (/pm vs /pm-v2).
export const resolveAnalyticsApp = <T extends AnalyticsAppIdentity>(
  pathname: string,
  apps: T[]
): T | undefined => {
  let best: { app: T; base: string } | undefined
  for (const app of apps) {
    const base = app.path.replace(/\/+$/, '') || '/'
    const matches =
      pathname === base || (base !== '/' && pathname.startsWith(`${base}/`))
    // Compare normalized paths, so trailing slashes can't outrank a deeper app.
    if (matches && (!best || base.length > best.base.length))
      best = { app, base }
  }
  return best?.app
}
